module.exports = __webpack_public_path__ + "media/step9_animation.e2f2ed34.mp4";